const langLists = [
    {
        origin: "The Americas",
        langs: [
            "Brazilian Portuguese",
            "Canadian French",
            "English",
            "French Creole",
            "Haitian Creole",
            "Navajo",
            "Quechua",
            "Spanish"
        ]
    },
    {
        origin: "Western Europe",
        langs:[
            "Catalan",
            "Danish",
            "Dutch",
            "Faroese",
            "Finnish",
            "Flemish",
            "French",
            "German",
            "Greek",
            "Icelandic",
            "Italian",
            "Norwegian",
            "Portuguese",
            "Spanish",
            "Swedish",
            "UK English / British English"
        ]
    },
    {
        origin: "Central & Eastern Europe",
        langs:[
            "Belarusian",
            "Bosnian",
            "Bulgarian",
            "Croatian",
            "Czeck",
            "Estonian",
            "Hungarian",
            "Latvian",
            "Lithuanian",
            "Macedonian",
            "Polish",
            "Romanian",
            "Russian",
            "Serbian",
            "Slovak",
            "Slovenian",
            "Turkish",
            "Ukrainian"
        ]
    },
    {
        origin: "Africa",
        langs:[
            "Amharic (Ethiopia)",
            "Dinka (Sudan)",
            "Ibo (Nigeria)",
            "Kirundi",
            "Mandinka",
            "Nuer (Nilo-Saharan)",
            "Oromo (Ethiopia)",
            "Kinyarwanda",
            "Shona (Zimbabwe)",
            "Somali",
            "Swahili",
            "Tigrigna (Ethiopia)",
            "Wolof",
            "Xhosa",
            "Yoruba",
            "Zulu"
        ]
    },
    {
        origin: "Middle East",
        langs:[
            "Arabic",
            "Dari",
            "Farsi",
            "Hebrew",
            "Kurdish",
            "Pashtu",
            "Punjabi",
            "Urdu (Pakistan)"
        ]
    },
    {
        origin: "Central Asia",
        langs:[
            "Armenian",
            "Azerbaijani",
            "Georgian",
            "Kazakh",
            "Mongolian",
            "Turkmen",
            "Uzbek"
        ]
    },
    {
        origin: "Southeast Asia",
        langs:[
            "Bengali",
            "Cham",
            "Chamorro (Guam)",
            "Gujarati (India)",
            "Hindi",
            "Indonesian",
            "Khmer (Cambodia)",
            "Kmhmu (Laos)*",
            "Korean",
            "Laotian",
            "Malayalam",
            "Malay",
            "Marathi (India)",
            "Marshallese",
            "Nepali",
            "Sherpa*",
            "Tamil",
            "Thai",
            "Tibetan",
            "Trukese (Micronesia)",
            "Vietnamese"
        ]
    },
    {
        origin: "Far East",
        langs:[
            "Amoy",
            "Burmese",
            "Cantonese",
            "Chinese",
            "Chinese-Simplified",
            "Chinese - Traditional",
            "Chiu Chow",
            "Chow Jo",
            "Fukienese",
            "Hakka (China)",
            "Hmong",
            "Hainanese",
            "Japanese",
            "Mandarin",
            "Mien",
            "Shanghainese",
            "Taiwanese",
            "Taishanese"
        ]
    },
    {
        origin: "South Pacific",
        langs:[
            "Fijian",
            "Palauan*",
            "Samoan",
            "Tongan",
            
        ]
    },
    {
        origin: "Philippines",
        langs:[
            "Bikol",
            "Cebuano",
            "IIocano",
            "IIongo",
            "Pampangan",
            "Pangasinan",
            "Tagalog",
            "Visayan"
            
        ]
    }
    
]

export default langLists;